import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <Link to="/help" className="text-amber-700 hover:text-amber-800 font-medium mb-4 inline-block">
        ← Back to Help Center
      </Link>
      
      <h1 className="text-4xl font-bold mb-6 text-amber-800 dark:text-amber-200">Terms of Service</h1>
      
      <div className="bg-white rounded-lg shadow-md p-6 dark:bg-gray-800 dark:text-gray-100 space-y-6">
        <div>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
            <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
          </p>
        </div>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">1. Acceptance of Terms</h2>
          <p className="text-gray-700 dark:text-gray-300">
            By accessing and using the QahwaHub mobile application and services, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">2. Description of Service</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-3">
            QahwaHub is a mobile application that allows users to:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
            <li>Browse coffee shops and cafes</li>
            <li>Place orders for food and beverages</li>
            <li>Earn and redeem loyalty points</li>
            <li>Subscribe to premium benefits</li>
            <li>Access location-based cafe recommendations</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">3. User Accounts</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
            <li>You are responsible for maintaining the confidentiality of your account credentials</li>
            <li>You agree to provide accurate and complete information when creating an account</li>
            <li>You are responsible for all activities that occur under your account</li>
            <li>You must notify us immediately of any unauthorized use of your account</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">4. Orders and Payment</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
            <li>All prices are displayed in Jordanian Dinars (JOD)</li>
            <li>Orders are subject to availability at the time of placement</li>
            <li>Payment methods accepted: Cash (in-store) and any payment methods currently enabled at checkout</li>
            <li>When online gateway payments are enabled, they are processed by PCI DSS compliant providers</li>
            <li>We do not store your full card details - card information is handled by payment providers</li>
            <li>Orders can be cancelled before preparation begins</li>
            <li>Refunds are processed according to cafe policies and may take 5-10 business days</li>
            <li>In-store payments can be made using cash or by scanning your QR code for points earning</li>
            <li>All transactions are final once the order is confirmed and payment is processed</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">5. Loyalty Points Program</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
            <li><strong>Points Earning:</strong>
              <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                <li>Premium subscribers: Earn 2 points per 1 JOD spent on <strong>drinks only</strong></li>
                <li>Earn <strong>1 point per 1 JOD</strong> on <strong>drinks only</strong> (coffee, tea, juices, smoothies — not food or pastries)</li>
                <li>Guest users: Cannot earn points (create an account to participate)</li>
                <li>Points are earned on online orders and in-store purchases when QR code is scanned</li>
                <li>Water and non-drink items do not earn points</li>
              </ul>
            </li>
            <li><strong>50 points</strong> can be redeemed for <strong>1 free coffee</strong> (up to the cheapest coffee price in the order)</li>
            <li>Free coffee from points is funded by Qahwahub, not deducted from café partner payouts</li>
            <li>Points have no cash value and cannot be transferred, sold, or exchanged</li>
            <li>Points expire after 12 months of account inactivity</li>
            <li>Points cannot be earned on orders paid entirely with points</li>
            <li>We reserve the right to modify the points program with 30 days notice</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">6. Premium Subscription</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
            <li>Premium subscription costs 2.50 JOD per month</li>
            <li>Premium members receive exclusive offers and notifications</li>
            <li>Subscription can be cancelled at any time through your profile</li>
            <li>No refunds for partially used subscription periods</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">8. QR Code and In-Store Payments</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
            <li>Each user account has a unique QR code for in-store payment identification</li>
            <li>QR codes can be scanned by cafe staff to process in-store payments and award points</li>
            <li>You are responsible for keeping your QR code secure and not sharing it with others</li>
            <li>Points are only awarded when your QR code is scanned during in-store payment</li>
            <li>Guest users cannot use QR codes for points earning</li>
            <li>We are not responsible for points not awarded if QR code is not scanned or scanned incorrectly</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">9. User Conduct</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-3">You agree not to:</p>
          <ul className="list-disc list-inside space-y-2 text-gray-700 dark:text-gray-300">
            <li>Use the service for any unlawful purpose</li>
            <li>Impersonate any person or entity</li>
            <li>Interfere with or disrupt the service</li>
            <li>Attempt to gain unauthorized access to any part of the service</li>
            <li>Submit false or misleading information</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">10. Intellectual Property</h2>
          <p className="text-gray-700 dark:text-gray-300">
            All content, features, and functionality of QahwaHub are owned by us and are protected by international copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">11. Limitation of Liability</h2>
          <p className="text-gray-700 dark:text-gray-300">
            QahwaHub acts as an intermediary between users and cafes. We are not responsible for the quality, safety, or delivery of food and beverages prepared by cafes. Any disputes regarding orders should be resolved directly with the cafe.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">12. Modifications to Service</h2>
          <p className="text-gray-700 dark:text-gray-300">
            We reserve the right to modify, suspend, or discontinue any part of the service at any time with or without notice. We are not liable to you or any third party for any modification, suspension, or discontinuation.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">13. Governing Law</h2>
          <p className="text-gray-700 dark:text-gray-300">
            These Terms of Service are governed by the laws of the Hashemite Kingdom of Jordan. Any disputes arising from these terms will be subject to the exclusive jurisdiction of the courts of Jordan.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold mb-3 text-amber-700 dark:text-amber-300">14. Contact Information</h2>
          <p className="text-gray-700 dark:text-gray-300">
            For questions about these Terms of Service, please contact us at:
          </p>
          <ul className="list-none space-y-1 text-gray-700 dark:text-gray-300 mt-2">
            <li>📧 Email: support@qahwahub.com</li>
            <li>📞 Phone: xxx-xxx-xxxx</li>
            <li>📍 Address: Amman, Jordan</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
